import { render, staticRenderFns } from "./ReporteSerieBase.vue?vue&type=template&id=20775dca&"
import script from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
export * from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
import style0 from "./ReporteSerieBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('20775dca', component.options)
    } else {
      api.reload('20775dca', component.options)
    }
    module.hot.accept("./ReporteSerieBase.vue?vue&type=template&id=20775dca&", function () {
      api.rerender('20775dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/ReporteSerieBase.vue"
export default component.exports